export const GreenEmailIcon = () => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0372 4.46147L8.76757 6.42324C8.24607 6.73614 7.59457 6.73614 7.07308 6.42324L3.80345 4.46147M4.62683 12.6952H11.2138C13.0328 12.6952 14.5073 11.2207 14.5073 9.40171V4.46147C14.5073 2.64252 13.0328 1.16797 11.2138 1.16797H4.62683C2.80788 1.16797 1.33333 2.64252 1.33333 4.46147V9.40171C1.33333 11.2207 2.80788 12.6952 4.62683 12.6952Z"
        stroke="#05796B"
        strokeWidth="0.988049"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
